// import * as types from './mutation-types'
// import api from '@/api'
// export const saveUserInfo = function({ commit, state }) {
//   if (state.user.id) {
//     return new Promise((resolve) => {
//       resolve(state.user)
//     })
//   } else {
//     return new Promise((resolve, reject) => {
//       api.user
//         .user_info_v2()
//         .then((res) => {
//           commit(types.SET_USER, res.data.user_info)
//           resolve(res.data.user_info)
//           if (res.code === 200) {
//           }
//         })
//         .catch((err) => {
//           console.log(err)
//         })
//     })
//   }
// }

import {
  Dialog
} from 'vant'

const actions = {
  SHOW_LIMIt_DIALOG({ state }, { phone, uId, isCenter }) {
    const { comefrom: { apply, usercenter } } = state
    if (isCenter) {
      location.href = usercenter
      // location.href = '//localhost:8888/#/user-info?id=167'
      return
    }
    Dialog
      .confirm({
        title: '暂无权限',
        message: '您还不是推广员，需申请成为推广员后才可使用该功能',
        messageAlign: 'left',
        className: 'limit',
        confirmButtonColor: '#fff',
        confirmButtonText: '马上申请'
      })
      .then(() => {
        location.href = `${apply}?phone=${phone}`
        // location.href = `//localhost:8888/#/apply?phone=${phone}`
      })
      .catch(() => {})
  }
}

export default actions
